<style>
    .bar {
        display: flex;
        align-items: flex-end;
        font-size: 14pt;
    }

    .bar .label {
        width: auto;
    }

    .bar .left.label {
        min-width: 150px;
    }

    .bar.nobar {
        display: none;
    }

    .expansion {
        /* background-color: red !important; */
        margin  : 0;
        height  : 0;
        opacity : 0;
        overflow: hidden;
        transition: all .7s cubic-bezier(0, 1, 0.5, 1);
    }

    .expansion .segment {
        font-size: 14pt;
        /* height: 90px; */
    }

    .expansion .segment b {
        display: inline-block;
        width: 90px;
        text-align: right;
        margin-right: 10px;
    }

    .expansion.active {
        margin: 30px;
        opacity: 1;
        overflow: visible;
    }

    .expansion.view.active {
        height: 150px;
    }

    .expansion.edit.active {
        height: 486px;
    }

    .expansion.view .only-on-edit, .view .input, .edit .detail {
        display: none !important;
        /* opacity : 0; */
    }

    .edit .input, .view .detail {
        display: inline-block;
    }

    .input.larger, .input.larger input {
        width: 500px;
    }

    .expansion.edit.active .only-on-edit {
        display: block;
    }

    .expansion.edit:not(.active) .only-on-edit {
        display: none;
    }

    .floated:after {
        content: "";
    }

    .floated .right {
        float: right;
    }
</style>

<script>
    import _              from 'lodash'
    import { getContext } from 'svelte'
    import * as api       from '../../shared/api.js'
    import Dropdown       from '../../shared/Dropdown.svelte'
    import Duration       from './Duration.svelte'

    export let groups = []
    export let group
    export let cookie
    export let expanded = -1
    export let onCancel = () => false
    export let isDirty  = () => false
    export let mode  = 'view'
    export let nobar = false
    export let closeOnCancel = true

    let copy = { ...cookie }
    
    let updating = false
    let removing = false
    let updateError = false
    let removeError = false
    
    const ctx  = getContext('cookies')

    $: isExpanded = expanded === cookie.id
    $: dirty = isDirty(cookie, copy)
    $: stopActions = removing || updating
    $: groupOpts = optionsGivenGroups(groups)

    const cookieTypes = [
        { id: 1, value: 'http'       , text: 'Cookie HTTP'                    },
        { id: 2, value: 'local'      , text: 'Local Storage (HTML)'           },
        { id: 3, value: 'flash'      , text: 'Local Shared Object (Flash)'    },
        { id: 4, value: 'silverlight', text: 'Isolated Storage (Silverlight)' },
        { id: 5, value: 'pixel'      , text: 'Pixel Tracker'                  },
        { id: 6, value: 'indexeddb'  , text: 'IndexedDB'                      },
        { id: 7, value: 'usb'        , text: 'Ultra Sound Beacon'             },
    ]
   
    const retentionTypes = [
        { id: 1, value: 'unlimited' , text: 'Permanente' },
        { id: 2, value: 'session'   , text: 'Sessão'     },
        { id: 3, value: '30d'       , text: '30 dias'    },
        { id: 4, value: '60d'       , text: '60 dias'    },
        { id: 5, value: '90d'       , text: '120 dias'   },
    ]

    function optionsGivenGroups(groups) {
        if(groups) {
            return groups.map(group => {
                return { id: group.id, text: group.name }
            })
        }
    }

    function optionFor(collection, value) {
        return collection.find(i => i.value == value)
    }

    function cancel() {
        toggle('edit')
        updateError = false
        onCancel()
    }

    function toggle(key) {
        if(!isExpanded) {
            mode = key
            expanded = cookie.id
        } else {
            cookie = { ...copy }
            if(closeOnCancel) {
                if (mode === key) {
                    expanded = -1
                    mode = 'view'
                } else {
                    mode = key
                }
            }
        }
        

        if('edit' === mode) {
            const el = document.getElementById(`${cookie.id}-name`)
            if(el)
            {
                el.select()
                el.focus()
            }
        }
    }

    function remove() {
        removing = true
        api
            .del(`/donut/${cookie.id}`)
            .then(api.toTextIf200)
            .then(() => {
                removing = false
                removeError = false
                ctx.cookieRemoved(cookie)
            })
            .catch(err => {
                removing = false
                removeError = true
            })
    }

    function update() {
        updating = true
        const method  = cookie.id === 0 ? 'POST' : 'PUT'
        const handler = cookie.id === 0 ? api.toJsonIf200 : api.toTextIf200
        const obj = _.omitBy(cookie, i => i === '')

        api
            .exec('/donut', method, obj)
            .then(handler)
            .then(discard => {
                updating = false
                updateError = false
                ctx.cookieUpdated(cookie)
                if(copy.id > 0) copy = { ...cookie }
                toggle('edit')
                onCancel() //HACK: closes the "new cookie form"
            })
            .catch(err => {
                console.log(err)
                updating = false
                if(err.status === 400) {
                    err.json().then(violations => {
                        updateError = violations
                    })
                } else {
                    updateError = true
                }
            })
    }

    function groupChanged(opt) {
        cookie.group = opt.id
        //console.log(opt, cookie, group)
    }
</script>

<div class="bar {mode}" class:nobar>
    <div class="left label">
        <!-- {cookie.id} -->
        <div class="ui violet big horizontal label">
            {cookie.name}
        </div>                                
    </div>
    <div style="flex: 1">
        {cookie.purpose}
    </div>
    <div>
        {#if removeError}
            <div class="ui red small label">Erro ao Remover</div>
        {/if}

        <button class="ui icon button" 
                class:loading={removing}
                disabled={stopActions}
                on:click={remove}>
            <i class="trash icon"/>
        </button>
        <button class="ui icon button" 
                disabled={stopActions}
                on:click={e => toggle('edit')}>
            <i class="edit icon"/>
        </button>
    </div>
</div>
<div class="expansion {mode}" class:active={isExpanded}>
    <div class="ui segments">
        <!-- <div class="ui segment">
            m: {mode}, e: {isExpanded} {expanded}
        </div> -->
        {#if groups && groups.length > 0}
            <div class="ui segment only-on-edit">
                <b  class="input label">
                    Grupo
                </b> 
                <div class="ui input">
                    <Dropdown   text     ='Tipo'
                                type     ='button'
                                selected ={groupOpts.find(g => g.id === group.id)}
                                noOption ={false} 
                                fluid    ={true}
                                options  ={groupOpts}
                                onChange ={ groupChanged } />
                </div>
            </div>
        {/if}
        <div class="ui segment only-on-edit">
            <b  class="input label" 
                class:error={updateError && updateError.name}>
                Nome
            </b> 
            <div class="ui input" 
                 class:error={updateError && updateError.name}>
                <input tabindex="0" id="{cookie.id}-name" bind:value={cookie.name} type="text" autocomplete="false">
            </div>
        </div>
        <div class="ui segment only-on-edit">
            <b  class="input label" 
                class:error={updateError && updateError.label}>
                Rótulo
            </b> 
            <div class="ui input" 
                 class:error={updateError && updateError.label}>
                <input tabindex="0" id="{cookie.id}-label" bind:value={cookie.label} type="text" autocomplete="false">
            </div>
        </div>
        <div class="ui segment only-on-edit">
            <b  class="input label" 
                class:error={updateError && updateError.purpose}>
                Propósito
            </b> 
            <div class="ui larger input" 
                 class:error={updateError && updateError.purpose}>
                <input  bind:value={cookie.purpose} type="text" autocomplete="false">
            </div>
        </div>
        <div class="ui segment">
            <b  class="input label" 
                class:error={updateError && updateError.domain}>
                Domínio
            </b>
            <span class="detail">{cookie.domain}</span>
            <div class="ui input" 
                 class:error={updateError && updateError.domain}>
                <input bind:value={cookie.domain} type="text" autocomplete="false">
            </div>
        </div>
        <div class="ui segment">
            <b  class="input label" 
                class:error={updateError && updateError.kind}>
                Tipo
            </b> 
            <span class="detail">{cookie.kind}</span> 
            <div class="ui input">
                <Dropdown   text     ='Tipo'
                            type     ='button'
                            error    ={updateError && updateError.kind}
                            selected ={optionFor(cookieTypes, cookie.kind)}
                            noOption ={false} 
                            fluid    ={true}
                            options  ={cookieTypes}
                            onChange ={ it => cookie.kind = it.value } />
            </div>
        </div>
        <div class="ui segment">
            <b  class="input label" 
                class:error={updateError && updateError.duration}>
                Validade
            </b>
            <span class="detail">{cookie.duration}</span>
            <div class="ui input">
                <!-- <span>[{cookie.duration}]</span>    -->
                <Duration duration={ cookie.duration } onChange={ v => { cookie.duration = v } }/>
            </div>
        </div>

        <div class="ui clearing segment only-on-edit">
            <div class="floated">
                <div class="right">

                    {#if updateError}
                        <div class="ui red small label">Erro ao Salvar</div>
                    {/if}

                    <button class:updating 
                            class:disabled={stopActions || !dirty}
                            class="ui primary button"
                            on:click={update}>
                        Salvar
                    </button>

                    <button class="ui button"
                            on:click={cancel}>
                        Cancelar
                    </button>

                </div>
            </div>
        </div>

    </div>
</div>

